/*
 * Reload the window when a breakpoint fires in order to allow the
 * proper server side components to be sent in the response.
 */
var BreakpointReloadController = (function ($) {

  var timer,
      timeout = 500;

  function ready() {
    // $(BreakpointController).on('crossBreakpoint', onCrossBreakpoint);
  }

  function onCrossBreakpoint() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      window.location.reload();
    }, timeout);

  }

  $(ready);

})(jQuery);
